// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Register from './pages/Register';
import BusinessRegistration from './components/Registration/BusinessRegistration';
import { NfpRegProvider } from './contexts/NfpRegContext';
import NfpRegistration from './components/Registration/NfpRegistration';
import NfpDashboard from './pages/NfpDashboard';
import NfpProfile from './pages/NfpProfile';
import NfpVerification from './pages/NfpVerification';
import OpsHome from './pages/OpsHome';
import OpsChangePassword from './pages/OpsChangePassword';
import OpsNfpMonitoring from './pages/OpsNfpMonitoring';
import OpsNfpReview from './pages/OpsNfpReview';
import OpsBusinessMonitoring from './pages/OpsBusinessMonitoring';
import OpsBusinessDetail from './pages/OpsBusinessDetail';
import OpsTransactionMatchQueue from './pages/OpsTransactionMatchQueue';
import OpsMoneyMovement from './pages/OpsMoneyMovement';
import OpsPerformance from './pages/OpsPerformance';
import OpsConsumerMetrics from './pages/OpsConsumerMetrics';
import OpsBusinessMetrics from './pages/OpsBusinessMetrics';
import OpsLoopHealth from './pages/OpsLoopHealth';
import { OpsMarketDetail, OpsMarketHotspots, OpsMarketsCatalog } from './pages/OpsMarkets';
import OpsUsers from './pages/OpsUsers';
import OpsConsumerDeletionQueue from './pages/OpsConsumerDeletionQueue';
import AuthGuard from './components/AuthGuard';
import RouteTracker from './components/RouteTracker';

// ✅ Make sure this path matches where you saved BusDash.jsx
import BusDash from './pages/BusDash';

// Keep these imports commented out until you want to enable those pages
// import Home from './pages/Home';
// import ConsumerInsights from './pages/ConsumerInsights';
// import PerformanceMetrics from './pages/PerformanceMetrics';
// import CampaignManagement from './pages/CampaignManagement';
// import Financials from './pages/Financials';
// import AccountSettings from './pages/AccountSettings';
// import CreateCampaign from './pages/CreateCampaign';
// import RypilIntelligence from './pages/RypilIntelligence';

// import Sidebar from './components/Layout/Sidebar';

// Sidebar layout for future pages
//function AppLayout() {
 // return (
 //   <div style={{ position: 'relative' }}>
 //     <Sidebar />
 //     <div style={{ marginLeft: '60px', padding: '20px' }}>
 //       <Outlet />
 //     </div>
 //   </div>
 // );
// }

export default function App() {
  return (
    <Router>
      <RouteTracker />
      <Routes>
        {/* Default → login */}
        <Route path="/" element={<Navigate to="/login" replace />} />

        {/* --- Full-Screen MVP Routes (NO SIDEBAR) --- */}
        
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/register" element={<Register />} />
        <Route path="/business-registration" element={<BusinessRegistration />} />
        <Route path="/accounts/:accountId/registration" element={<BusinessRegistration />} />
        <Route path="/nfp/register" element={<NfpRegProvider> <NfpRegistration /> </NfpRegProvider>} />

        {/* 🚀 MVP Home Screen Renders Full-screen 🚀 */}
        <Route path="/accounts/:accountId/dashboard" element={<BusDash />} />
        <Route path="/home" element={<BusDash />} />
        <Route path="/home/:brandId" element={<BusDash />} />
        <Route path="/nfp" element={<NfpDashboard />} />
        <Route path="/nfp/profile" element={<NfpProfile />} />
        <Route path="/nfp/verification" element={<NfpVerification />} />
        <Route path="/ops" element={<AuthGuard><OpsHome /></AuthGuard>} />
        <Route path="/ops/change-password" element={<AuthGuard><OpsChangePassword /></AuthGuard>} />
        <Route path="/ops/nfps" element={<AuthGuard><OpsNfpMonitoring /></AuthGuard>} />
        <Route path="/ops/nfps/:id" element={<AuthGuard><OpsNfpReview /></AuthGuard>} />
        <Route path="/ops/businesses" element={<AuthGuard><OpsBusinessMonitoring /></AuthGuard>} />
        <Route path="/ops/businesses/:id" element={<AuthGuard><OpsBusinessDetail /></AuthGuard>} />
        <Route path="/ops/transaction-match-queue" element={<AuthGuard><OpsTransactionMatchQueue /></AuthGuard>} />
        <Route path="/ops/money-movement" element={<AuthGuard><OpsMoneyMovement /></AuthGuard>} />
        <Route path="/ops/performance" element={<AuthGuard><OpsPerformance /></AuthGuard>} />
        <Route path="/ops/consumer-metrics" element={<AuthGuard><OpsConsumerMetrics /></AuthGuard>} />
        <Route path="/ops/business-metrics" element={<AuthGuard><OpsBusinessMetrics /></AuthGuard>} />
        <Route path="/ops/loop-health" element={<AuthGuard><OpsLoopHealth /></AuthGuard>} />
        <Route path="/ops/markets" element={<AuthGuard><OpsMarketsCatalog /></AuthGuard>} />
        <Route path="/ops/markets/hotspots" element={<AuthGuard><OpsMarketHotspots /></AuthGuard>} />
        <Route path="/ops/markets/:marketKey" element={<AuthGuard><OpsMarketDetail /></AuthGuard>} />
        <Route path="/ops/consumers/support" element={<AuthGuard><OpsConsumerDeletionQueue /></AuthGuard>} />
        <Route path="/ops/consumers/duplicate-accounts" element={<AuthGuard><OpsConsumerDeletionQueue /></AuthGuard>} />
        <Route path="/ops/consumers/deletion-queue" element={<AuthGuard><OpsConsumerDeletionQueue /></AuthGuard>} />
        <Route path="/ops/users" element={<AuthGuard><OpsUsers /></AuthGuard>} />


        {/* --------------------------------------------- */}

        {/* 🚧 Future: enable these when ready, they will use AppLayout (Sidebar)
        <Route element={<AppLayout />}>
          <Route path="/consumer-insights" element={<ConsumerInsights />} />
          <Route path="/performance-metrics" element={<PerformanceMetrics />} />
          <Route path="/campaign-management" element={<CampaignManagement />} />
          <Route path="/financials" element={<Financials />} />
          <Route path="/account-settings" element={<AccountSettings />} />
          <Route path="/create-campaign" element={<CreateCampaign />} />
          <Route path="/rypil-intelligence" element={<RypilIntelligence />} />
        </Route>
        */}

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}
